import { NotificationStatus } from '@cp-shared-19/frontend-ui';
import { Notification } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EditStatus } from '../enums';

type PaymentDayChangeNotificationProps = {
    editStatus: EditStatus;
};

type NotificationProps = {
    testId: string;
    status: NotificationStatus;
    headline?: string;
    text: string;
};

export const PaymentDayNotification: React.FC<PaymentDayChangeNotificationProps> = ({ editStatus }) => {
    const { t } = useTranslation('financial-details');
    const { t: cms } = useTranslation('errors-cms');
    const prefix = 'collection-date-section.edit.notification';
    const prefixCms = 'collection-date-section.notification';

    if (editStatus === EditStatus.NOT_PERFORMED || editStatus === EditStatus.USER_WITH_NO_EMAIL_CODE) {
        return null;
    }

    const getNotificationProps = (): NotificationProps => {
        switch (editStatus) {
            case EditStatus.SUCCESS:
                return {
                    testId: 'change-success',
                    status: NotificationStatus.warning,
                    headline: t(`${prefix}.success.title`),
                    text: t(`${prefix}.success.text`),
                };
            case EditStatus.ALREADY_IN_PROGRESS:
                return {
                    testId: 'already-in-progress',
                    status: NotificationStatus.warning,
                    text: t(`${prefix}.already-in-progress.text`),
                };
            case EditStatus.ERROR:
                return {
                    testId: 'api-error',
                    status: NotificationStatus.error,
                    text: cms(`financial-details.${prefixCms}.error.text`),
                };
        }
    };

    const { text, headline, ...notificationProps } = getNotificationProps();

    return (
        <Notification
            {...notificationProps}
            title={headline ?? ''}
            hideTitle={!headline}
            visible
            showCloseButton={false}
        >
            {text}
        </Notification>
    );
};
